// extracted by mini-css-extract-plugin
module.exports = {"notifications":"notification_notifications__3ha5Y"};